
































import Vue from 'vue'
import { Checkbox } from '@raksul/kamii-vue'
import BaseImage from '@/common/components/BaseImage.vue'
import { AdditionalOption } from '@/common/types'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import { formatOneDecimal } from '@/common/utils/common'

export default Vue.extend({
  components: {
    Checkbox,
    BaseImage
  },
  props: {
    option: {
      type: Object as () => AdditionalOption,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    imagePlaceholder() {
      return SVG_PLACEHOLDER_IMAGES.ADDITIONAL_OPTION_IMAGE
    }
  },
  methods: {
    formatOneDecimal
  }
})
